import { Link, LinkProps, media, P } from 'ia-react-core';
import { PageMainTitle } from 'omni-package-react-core';
import { FC } from 'react';
import styled from 'styled-components';

export const StyledSection = styled.section`
  text-align: center;

  ${media.sm`
    text-align: inherit;
  `}
`;

export const StyledP = styled(P)`
  margin-bottom: 36px;
  background-color: inherit;
  border: inherit;
  outline: none;

  &:focus:not(&:focus-visible) {
    box-shadow: none;
  }
  &:focus {
    box-shadow: 0 0 3px 0 ${({ theme }) => theme.colors.lighter};
  }
`;

export const StyledPageMainTitle = styled(PageMainTitle)`
  margin-bottom: 36px;
`;

export const StyledLink = styled<FC<LinkProps>>(Link)`
  font-weight: inherit;
  text-decoration: underline;
  white-space:normal;
  display:contents;
  color: ${({ theme }) => theme.colors.blue5};
  cursor: pointer;

  &:hover {
    text-decoration: inherit;
  }
  &:active {
    color: ${({ theme }) => theme.colors.blue10};
    text-decoration: inherit;
  }
`;

export const StyledNoBreakWrapper = styled.span`
  display: inline;
  text-decoration: underline;
  text-decoration-color: ${({ theme }) => theme.colors.blue5};
  white-space: nowrap;
  overflow-wrap: break-word;
`;
